import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";
const DEFAULT_SECONDARY_COLOR = "var(--label-tertiary)";

const ROTATE_VALUE_TOP_LEFT_BOTTOM_RIGHT = 0;
const ROTATE_VALUE_TOP_RIGHT_BOTTOM_LEFT = 90;

enum RadiusTwoSide {
    TopLeftBottomRight = "topLeftBottomRight",
    TopRightBottomLeft = "topRightBottomLeft"
}

interface Props extends IconProps {
    side?: RadiusTwoSide;
}

function calculateRotationByPosition(side: RadiusTwoSide): number {
    switch (side) {
        case RadiusTwoSide.TopLeftBottomRight:
            return ROTATE_VALUE_TOP_LEFT_BOTTOM_RIGHT;
        case RadiusTwoSide.TopRightBottomLeft:
            return ROTATE_VALUE_TOP_RIGHT_BOTTOM_LEFT;
        // no default
    }
}

function IconRadiusTwoSidesAlignment({
    class: cssClass,
    color,
    secondaryColor,
    side = RadiusTwoSide.TopLeftBottomRight
}: Props) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const secondaryFill = secondaryColor ?? `var(--icon-secondary-color, ${DEFAULT_SECONDARY_COLOR})`;
    const rotation = calculateRotationByPosition(side);

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ transform: `rotate(${rotation}deg)` }} xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M1 2v2H0V2a2 2 0 0 1 2-2h2v1H2a1 1 0 0 0-1 1z"/>
            <path fill={secondaryFill} d="M11 2v2h1V2a2 2 0 0 0-2-2H8v1h2a1 1 0 0 1 1 1zM1 10V8H0v2a2 2 0 0 0 2 2h2v-1H2a1 1 0 0 1-1-1z"/>
            <path fill={fill} d="M11 10V8h1v2a2 2 0 0 1-2 2H8v-1h2a1 1 0 0 0 1-1z"/>
        </svg>
    );
}

export default IconRadiusTwoSidesAlignment;
export { RadiusTwoSide };
